import { Globe } from 'lucide-react';
import { cn } from '@/lib/utils';
import { normalizeFlagCode } from '@/lib/flags';

const DEFAULT_CLASSNAME = 'h-[14px] w-[20px] rounded-[2px] object-cover shadow-[0_0_0_1px_rgba(255,255,255,0.08)]';

export const FlagIcon = ({ code, className, alt = '' }) => {
  const normalizedCode = normalizeFlagCode(code);

  if (!normalizedCode) {
    return <Globe className={cn('h-4 w-4 text-current', className)} aria-hidden="true" />;
  }

  return (
    <img
      src={`${process.env.PUBLIC_URL || ''}/flags/${normalizedCode}.svg`}
      alt={alt}
      aria-hidden={alt ? undefined : 'true'}
      className={cn(DEFAULT_CLASSNAME, className)}
      loading="lazy"
      decoding="async"
    />
  );
};

export default FlagIcon;
